// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-k_gE","advertDetailContactItem__link":"c-k_gF","advertDetailContactItem__stub":"c-k_gG"};